<template>
  <div>
   	<a-modal title="岗位列表-编辑" :visible="addPostVisible" @cancel="closePostVisible"
					width="50%" @ok="submitParameter">
					<a-form-model :model="postForm" ref="postFormRef" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
							<!-- 岗位详情 -->
						<div>
							<span class="sizeStyle">表单信息</span>
						</div>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="行业名称" prop="quotePostInfo.industryId" :rules="{
								  required: true,
								  message: '请输入行业名称',
								  trigger: 'change',
								}">
									<a-select  allowClear placeholder="行业名称" v-model="postForm.quotePostInfo.industryId" @change="changeName">
								       <a-select-option :value="item.id" v-for="(item, index) in datalist"
											:key="index">
											{{ item.industryName }}
										</a-select-option>
							        </a-select>
								</a-form-model-item>
                            </a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="岗位名称" prop="quotePostInfo.postName" :rules="{
							  required: true,
							  message: '请输入岗位名称',
							  trigger: 'change',
							}">
									<a-input v-model="postForm.quotePostInfo.postName" placeholder="岗位名称"  />
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
                               <div v-for="(item2, index) in postForm.existsList" :key="index"  >
							<a-row>
								<div class="pay_top">
									<span class="form_title" >危害因素({{index+1}})</span>
									<span class="close_icon" @click="deletePost2(index)" v-if="postForm.existsList.length > 1 || postForm.quoteHarmFactorList > 1"> 删除 </span>
								</div>
							</a-row>
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="危害因素名称" prop="factorName" >
										<a-select allowClear placeholder="危害因素" v-model="item2.baseId" disabled>
										<a-select-option :value="item.id" v-for="(item, index) in exitList"
											:key="index" :title="item.fullName" >
                                           {{item.fullName}}
										</a-select-option>
										</a-select>
									</a-form-model-item>
								</a-col>
							</a-row>	
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="单价(元)">
										<a-input v-model="item2.price" type="number" placeholder="单价(元)" disabled></a-input>
									</a-form-model-item>
								</a-col>
							</a-row>	
						
					    </div>
					    <div v-for="(item1, index) in postForm.quoteHarmFactorList" :key="index"  >
							<a-row>
								<div class="pay_top">
									<span class="form_title" >新增危害因素({{index+1}})</span>
									<span class="close_icon" @click="deletePost(index)" v-if="postForm.existsList.length >= 1"> 删除 </span>
								</div>
							</a-row>
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="危害因素名称" prop="factorName" >
										<a-select allowClear placeholder="危害因素" v-model="item1.fullName" show-search :filter-option="false" @blur="restData" @search="searchThings" @popupScroll="eventThing"
										@change="changeName1($event, index)" maxTagPlaceholder :disabled="item1.disabled && postType == 1">
										<a-select-option :value="item.id" v-for="(item, index) in factorList"
											:key="index" :title="item.fullName" >
                                           {{item.fullName}}
										</a-select-option>
										</a-select>
									</a-form-model-item>
								</a-col>
							</a-row>	
							<a-row>
								<a-col :span="24">
									<a-form-model-item label="单价(元)">
										<a-input v-model="item1.price" type="number" placeholder="单价(元)" disabled></a-input>
									</a-form-model-item>
								</a-col>
							</a-row>	
						
					    </div>
					 	</a-row>
						<a-row>
							<div class="rowBox">
								<a-button type="primary" @click="addPush"> 添加危害因素 </a-button>
							</div>
						</a-row>

				</a-form-model>
			</a-modal>
  </div>
</template>

<script>
import {
  delete_factor,
  getFactorDetail,
  getUserListDetail,
  industryInfo,
  industryInfo_post,
  postInfo,
  addPostWithHarmFactor,
  editPostWithHarmFactor,
  industryInfo_details,
  industryInfo_put,
  postInfo_details,
  postInfo_put,
  baseFactor,
  getCategoryTree,
  subCategory,
  baseFactor_add,
  factor_details,
  editFactors_put,
  factor_list,
  deleteIndustryInfo,
  deleteFactor,
  getUserList,
} from '@/api/Industry'
export default {
    props: [

    ],
    data() {
        return {
			data: '',
			time: '',
			columns: [
				{
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    // width: 120,
    ellipsis: true,
  },
  {
    title: '危害因素名称',
    dataIndex: 'fullName',
    key: 'fullName',
  },
  {
    title: '单价(元)',
    dataIndex: 'price',
    key: 'price',
    // width: 80,
  },
			],
		postType: undefined,
        addPostVisible: false,
        postForm: {
            quotePostInfo: {
                industryId: undefined,
                postName: '',

            },
            quoteHarmFactorList: [
            {
              price: '',
			  baseId: undefined,
              factorName: '',
            },
            ],
            existsList: []
        },
		harmfulData: [],
		pagination4: {
            current: 1,
            pageSize: 10,
            total: 0,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showLessItems: true,
            showSizeChanger: true,
        },
		factorList: [],
		// 行业列表
		datalist: [],
		rowId: '',
		pageNumber: 1,
		pages: undefined,
        exitList: [],
        ordinalNumber: undefined,
		type: undefined,
		timeout: null
        }
        
    },
    methods: {
		resetData() {
			this.factorList = []
			console.log(this.factorList, 'this.factorList=====================')
			this.pageNumber = 1
			this.getList()
			console.log(this.factorList, 'this.factorList=====================')
		},
		searchThings(data) {
			//添加防抖
			 clearTimeout(this.timeout)
         this.timeout = setTimeout(() => {
            //调用方法
				//查询数据
			// return this.factorList.splice(0,2)
			console.log(data, 'data==========================')
				getUserList({
				pageNum: 1,
				pageSize: 600,
				factorName: data,
				categoryId: 1002
			}).then((res) => {
				this.type = 1
				this.factorList = []
				console.log(this.factorList, 'this.factorList+++++++++++++++++++++++')
				this.pages =  res.total
				// this.$forceUpdate()
                this.factorList = [...this.factorList,...res.data]
				// this.factorList.splice(1,0)
				// this.$forceUpdate()
				
            console.log(this.factorList, 'this.factorList+++++++++++++++++++++++')
            })
			

         }, 500)


		


		},
		eventThing(e) {
    const {target} = e;
    const scrllHeight = target.scrollHeight - target.scrollTop;
    const clientHeight = target.clientHeight;
    // 下拉框不下拉的时候
    if(scrllHeight ===0 && clientHeight ===0){
        this.pageNumber = 1;
    } else if(scrllHeight - clientHeight == 0){ // 下拉到底部时
        if(this.pageNumber < this.pages){
            // 如果滑到底部，则加载下一页
            this.pageNumber++
			if(this.type == 1) {
				this.searchThings()
			} else {
				this.getList()
			}

			// this.getList()
            // this.getListDataCode(this.parentCode)
        }
    }
     
			// console.log(e, 'e========================')

		},
        //删除已有岗位
        deletePost2(index) {
            this.postForm.existsList.splice(index, 1)

        },
		//删除岗位
		deletePost(index) {
			this.postForm.quoteHarmFactorList.splice(index, 1)

		},
		// 关闭弹出
		closePostVisible() {
			this.addPostVisible = false
			this.factorList = []
			this.pageNumber = 1
			if(this.postType == 0 || this.postType == 1) {
				this.postForm.quotePostInfo.industryId = ''
			  this.postForm.quotePostInfo.postName = ''
			  this.postForm.quotePostInfo.baseId = ''
			  this.postForm.quoteHarmFactorList = []
			  this.postForm.quoteHarmFactorList.push({
                price: '',
                factorName: '',
				fullName: undefined
              })
				this.$refs.postFormRef.resetFields()
			}

		},
		submitParameter() {
          this.postForm.quoteHarmFactorList = [...this.postForm.quoteHarmFactorList,...this.postForm.existsList]
			if(this.postType == 0) {
					this.$refs.postFormRef.validate((valid) => {
        if (valid) {
          addPostWithHarmFactor({
            quotePostInfo: this.postForm.quotePostInfo,
            quoteHarmFactorList: this.postForm.quoteHarmFactorList
          }).then((res) => {
            if (res.code == 200) {
			  this.postForm.quotePostInfo.industryId = ''
			  this.postForm.quotePostInfo.postName = ''
			  this.postForm.quotePostInfo.baseId = ''
			  this.postForm.quoteHarmFactorList = []
			  this.postForm.quoteHarmFactorList.push({
                price: '',
                factorName: '',
              })
			//   this.postForm.quoteHarmFactorList.splice(2, this.postForm.quoteHarmFactorList.length-1)
			//   this.postForm.quoteHarmFactorList[0].baseId= undefined
			//   this.postForm.quoteHarmFactorList[0].price= ''
              this.$message.success('新增成功')
              this.addPostVisible = false
              this.$emit('getPostData')
              this.$refs.postFormRef.resetFields()
            //   this.this.postForm.quotePostInfo.industryName = ''
			
            } else {
              this.$message.success(res.msg)
            }
          })
        }
      })

			} else if (this.postType == 1) {
				//编辑岗位提交数据
				  this.$refs.postFormRef.validate((valid) => {
        if (valid) {
		Object.assign(this.postForm.quotePostInfo,{id:this.rowId})
          editPostWithHarmFactor({
            quotePostInfo: this.postForm.quotePostInfo,
            quoteHarmFactorList: this.postForm.quoteHarmFactorList
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功')
			  this.postForm.quotePostInfo.industryId = ''
			  this.postForm.quotePostInfo.postName = ''
			  this.postForm.quotePostInfo.baseId = ''
			  this.postForm.quoteHarmFactorList = []
			  this.postForm.quoteHarmFactorList.push({
                price: '',
                factorName: '',
              })
			//   this.postForm.quoteHarmFactorList.splice(2, this.postForm.quoteHarmFactorList.length-1)
			//   this.postForm.quoteHarmFactorList[0].baseId= undefined
			//   this.postForm.quoteHarmFactorList[0].price= ''
              this.addPostVisible = false
              this.$refs.postFormRef.resetFields()
			   this.$emit('getPostData')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
			// this.postedit()

			}
	

		},
		addPush() {
		//  Object.assign(this.postForm, {
		// 	quoteHarmFactorList : []
		//  })
         this.postForm.quoteHarmFactorList.push({
        price: '',
        factorName: '',
        })
        this.$forceUpdate()
        },
		// useCarDateChange(value, dateString) {
		// 	console.log(dateString, 'this.data, this.datathis.datathis.datathis.datathis.data')

		// },
		// onChange(value, dateString) {
		// 	console.log(dateString, 'this.data, this.datathis.datathis.datathis.datathis.data')

		// },
		// onChange1(value, dateString) {
		// 	console.log(dateString, 'timetimetimetimetimetimetimetimetimetimetimetimetimetime')

		// },
        //获取当前页面列表
        init(data) {
	
            this.addPostVisible = true
			this.postType = data.postType
		    if(data.postType == 1) {
				this.rowId = data.rowId
				//岗位编辑
				// 获得编辑的数据
			postInfo_details(data.rowId).then((res) => {
				this.postForm.quotePostInfo.industryId = res.data.industryId
				this.postForm.quotePostInfo.postName = res.data.postName
			})
			getUserListDetail({ postId: data.rowId }).then((res) => {
                this.ordinalNumber = res.data.length
                	this.postForm.existsList = res.data
				for(var i = 0; i < res.data.length; i++) {
					Object.assign(this.postForm.existsList[i], {
						baseId: res.data[i].id,
						disabled: true

					})
				}
				// 	this.postForm.quoteHarmFactorList = res.data
				// for(var i = 0; i < res.data.length; i++) {
				// 	Object.assign(this.postForm.quoteHarmFactorList[i], {
				// 		baseId: res.data[i].id,
				// 		disabled: true

				// 	})
				// }
				console.log(res.data1, 'res.data1res.data1res.data1res.data1res.data1res.data1')
			})
				} else if(data.postType == 1) {
				this.postForm.quotePostInfo.industryId = undefined
			  this.postForm.quotePostInfo.postName = ''
			  this.postForm.quotePostInfo.baseId = ''
			  this.postForm.quoteHarmFactorList = []
			  this.postForm.quoteHarmFactorList.push({
                price: '',
                factorName: '',
              })
			}
            //获取危害因素exitList
            getUserList({
				categoryId: 1002
			}).then((res) => {
              this.exitList = res.data
            })
			//获取危害因素列表factorList
			this.getList()
			//获取行业列表datalist
			industryInfo({
                  projectId: 1
                 }).then((res) => {
                  this.datalist = res.data
                 console.log(this.datalist, 'this.datalist=========================================')
            })

		
				
			


			// else if(data.postType == 0) {
			// 	// 岗位新增

			// }


        },
		getList() {
			getUserList({
				pageNum: this.pageNumber,
				pageSize: 600,
				categoryId: 1002

			}).then((res) => {
              this.factorList = [...this.factorList,...res.data]
				this.pages =  res.total
            console.log(this.factorList, 'this.factorList1+++++++++++++++++++++++')
            })

		},
		//下拉列表搜索
		 filterOption(input, option) {
				// return (
				// 	option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				// );
			},
		//危害因素变化
		changeName1(e, index){
			this.type = 0
			console.log(e,index, '==========================')
			this.exitList.forEach(item => {
				if(item.id == e){
					this.postForm.quoteHarmFactorList[index].price = item.price
					this.postForm.quoteHarmFactorList[index].baseId = item.id
					this.postForm.quoteHarmFactorList[index].fullName = item.fullName
					this.postForm.quoteHarmFactorList[index].factorName = item.factorName
				}

			})
			this.factorList = []
			for(var i=0; i<this.pageNumber; i++) {
				getUserList({
				pageNum: i+1,
				pageSize: 600,
				categoryId: 1002
				
			}).then((res) => {
              this.factorList = [...this.factorList,...res.data]
				this.pages =  res.total
            console.log(this.factorList, 'this.factorList1+++++++++++++++++++++++')
            })


			}

		}
    }

}
</script>

<style>
.close_icon {
  font-size: 10px;
  color: red;
  cursor: pointer;
  margin-bottom: 10px;
}
.form_title {
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 17px;
  color: #999;
}
.pay_top {
  width: 100%;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>